import React from 'react';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

const checkStyle = { ...s.li, listStyleType: '"✓  "' };

function BlogArticleChecklistCybersecurite() {
  return (
    <BlogArticleLayout
      tag="Guides pratiques"
      title="Checklist cybersécurité entreprise : les points à vérifier"
      date="24 septembre 2026"
      ctaTitle="Transformez cette checklist en plan d'action chiffré"
      ctaText="Le diagnostic gratuit reprend ces points, les évalue précisément pour votre entreprise, et les priorise dans un plan d'action sur quatre semaines."
    >
      <p style={s.intro}>
        Voici une checklist volontairement courte et concrète, pensée pour un dirigeant non technique. Elle ne
        remplace pas un audit complet, mais elle permet de repérer rapidement les manques les plus fréquents
        en PME.
      </p>

      <h2 style={s.h2}>Accès et mots de passe</h2>
      <ul style={s.ul}>
        <li style={checkStyle}>Chaque salarié dispose de son propre identifiant — aucun compte n'est partagé entre plusieurs personnes.</li>
        <li style={checkStyle}>Les mots de passe des comptes sensibles sont uniques et suffisamment complexes.</li>
        <li style={checkStyle}>Une double authentification est activée sur les outils critiques (messagerie, banque en ligne, hébergement).</li>
        <li style={checkStyle}>Les accès d'un salarié qui quitte l'entreprise sont désactivés le jour même.</li>
      </ul>

      <h2 style={s.h2}>Sauvegardes</h2>
      <ul style={s.ul}>
        <li style={checkStyle}>Les données critiques sont sauvegardées automatiquement, sans dépendre d'une action manuelle.</li>
        <li style={checkStyle}>Au moins une copie de sauvegarde est stockée hors de votre réseau principal.</li>
        <li style={checkStyle}>Une restauration a déjà été testée concrètement, pas seulement supposée fonctionnelle.</li>
      </ul>

      <h2 style={s.h2}>Postes de travail et mises à jour</h2>
      <ul style={s.ul}>
        <li style={checkStyle}>Les systèmes d'exploitation et logiciels sont mis à jour régulièrement.</li>
        <li style={checkStyle}>Un antivirus ou une solution de protection équivalente est actif sur l'ensemble des postes.</li>
        <li style={checkStyle}>Les équipements professionnels perdus ou volés peuvent être verrouillés ou effacés à distance.</li>
      </ul>

      <h2 style={s.h2}>Sensibilisation des équipes</h2>
      <ul style={s.ul}>
        <li style={checkStyle}>Vos équipes ont déjà été sensibilisées, même brièvement, aux tentatives de phishing.</li>
        <li style={checkStyle}>Une procédure simple existe pour signaler un email ou un message suspect.</li>
        <li style={checkStyle}>Les demandes de virement inhabituelles font l'objet d'une double vérification systématique.</li>
      </ul>

      <h2 style={s.h2}>Prestataires et sous-traitants</h2>
      <ul style={s.ul}>
        <li style={checkStyle}>Vous savez précisément quels prestataires ont accès à vos données ou systèmes.</li>
        <li style={checkStyle}>Vos contrats avec ces prestataires prévoient des engagements de sécurité minimaux.</li>
      </ul>

      <h2 style={s.h2}>Réponse à incident</h2>
      <ul style={s.ul}>
        <li style={checkStyle}>Une procédure écrite, même courte, précise qui prévenir en cas d'incident.</li>
        <li style={checkStyle}>Vous savez si votre entreprise est soumise à une obligation de notification (RGPD, NIS2) et dans quels délais.</li>
      </ul>

      <p>
        Si plusieurs cases restent à cocher, ce n'est pas une anomalie : c'est précisément la situation de
        départ la plus fréquente chez les PME qui n'ont jamais formalisé leur cybersécurité. L'enjeu n'est pas
        d'être parfait immédiatement, mais de savoir où concentrer l'effort en premier.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleChecklistCybersecurite;
